import { render, staticRenderFns } from "./first-delete-bulk-modal.vue?vue&type=template&id=274c0dc7"
import script from "./first-delete-bulk-modal.ts?vue&type=script&lang=ts&external"
export * from "./first-delete-bulk-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./first-delete-bulk-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274c0dc7')) {
      api.createRecord('274c0dc7', component.options)
    } else {
      api.reload('274c0dc7', component.options)
    }
    module.hot.accept("./first-delete-bulk-modal.vue?vue&type=template&id=274c0dc7", function () {
      api.rerender('274c0dc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/first-delete-bulk-modal/first-delete-bulk-modal.vue"
export default component.exports